export const ROLE_ADMIN = 'admin';
export const ROLE_MANAGER = 'manager';
export const ROLE_USER = 'user';

export const TUTOR_ANA_ID = 'UdYGi021QOU0gCIH1HW2mLrZGul1';
export const TUTOR_ANA_NAME = 'Tutor Ana';

//export const TUTOR_ALELI_ID = 'tFp2tCPVGjZX4bWhr1RQ7B4MuCw2';  // DEV
export const TUTOR_ALELI_ID = 'kxulvnyRR0RmfSGgHuVSPCinBJ83'; 
export const TUTOR_ALELI_NAME = 'Tutor Aleli'; // ROLE=ADMIN

// export const TUTOR_DEKEL_ID = 'Mnrmt5yWcgNe79jZ63bGSPVl2s73'; // DEV
export const TUTOR_DEKEL_ID = 'Pg31dA6dZbZ7TD7M2Q3aB0FV6W73';
export const TUTOR_DEKEL_NAME = 'Tutor Flemics'; // ROLE=ADMIN